import http from "../http"

class PerformanceService {

    async listGoalPlans(page, data) {
        const rqst = await http.post('goalplan/list/?page=' + page, data)
        return rqst.data
    }

    async createGoalPlan(data) {
        const rqst = await http.post('goalplan/create/', data)
        return rqst.data
    }

    async updateGoalPlan(data) {
        const rqst = await http.post('goalplan/update/', data)
        return rqst.data
    }

    async getGoalPlan(id) {
        let data = {
            company_id: localStorage.getItem("companyId"),
            id: id
        }
        const rqst = await http.post('/goalplan/get/', data)
        return rqst.data
    }

    async deleteGoalPlan(id) {
        let data = {
            company_id: localStorage.getItem("companyId"),
            id: id
        }
        const rqst = await http.post('/goalplan/delete/', data)
        return rqst.data
    }

    async listGoals(page, data) {
        const rqst = await http.post('goal/list/?page=' + page, data)
        return rqst.data
    }

    async listGoalsByCategory(items) {

        let data = {
            company_id: localStorage.getItem("companyId"),
        }

        if (items) {
            data = {...data, ...items}
        }

        const rqst = await http.post('goal/list/bycategory/', data)
        return rqst.data
    }

    async createGoal(data) {
        const rqst = await http.post('goal/create/', data)
        return rqst.data
    }

    async updateGoal(data) {
        const rqst = await http.post('goal/update/', data)
        return rqst.data
    }

    async getGoal(id) {
        let data = {
            company_id: localStorage.getItem("companyId"),
            id: id
        }
        const rqst = await http.post('goal/get/', data)
        return rqst.data
    }

    async deleteGoal(id) {
        let data = {
            company_id: localStorage.getItem("companyId"),
            id: id
        }
        const rqst = await http.post('goal/delete/', data)
        return rqst.data
    }

    async createGoalStatus(data) {
        const rqst = await http.post('goal/status/create/', data)
        return rqst.data
    }

    async listGoalStatus(page, data) {
        const rqst = await http.post('goal/status/list/?page=' + page, data)
        return rqst.data
    }

    async createPerformanceReview(data) {
        const rqst = await http.post('performance/review/create/', data)
        return rqst.data
    }

    async getPerformanceReview(id) {
        let data = {
            company_id: localStorage.getItem("companyId"),
            id: id
        }
        const rqst = await http.post('performance/review/get/', data)
        return rqst.data
    }

    async listPerformanceReview(page, data) {
        const rqst = await http.post('performance/review/list/?page=' + page, data)
        return rqst.data
    }

    async listPerformanceReviewOnly(page, data) {
        const rqst = await http.post('performance/review/list/only/?page=' + page, data)
        return rqst.data
    }

    async listPerformanceReviewEmployee(page, data) {
        const rqst = await http.post('performance/review/employee/list/?page=' + page, data)
        return rqst.data
    }

    async updatePerformanceReview(data) {
        const rqst = await http.post('performance/review/update/', data)
        return rqst.data
    }

    async deletePerformanceReview(id) {
        let data = {
            company_id: localStorage.getItem("companyId"),
            id: id
        }
        const rqst = await http.post('performance/review/delete/', data)
        return rqst.data
    }

    async createJobPerformance(data) {
        const rqst = await http.post('job-performance/create/', data)
        return rqst.data
    }

    async updateJobPerformance(data) {
        const rqst = await http.post('job-performance/update/', data)
        return rqst.data
    }

    async deleteJobPerformance(data) {
        const rqst = await http.post('job-performance/delete/', data)
        return rqst.data
    }

    async createAssessmentQuestion(data) {
        const rqst = await http.post('assessment-question/create/', data)
        return rqst.data
    }

    async updateAssessmentQuestion(data) {
        const rqst = await http.post('assessment-question/update/', data)
        return rqst.data
    }

    async deleteAssessmentQuestion(data) {
        const rqst = await http.post('assessment-question/delete/', data)
        return rqst.data
    }

    async myTeamPerformance(page, data) {
        const rqst = await http.post('performance/my/team/view/?page=' + page, data)
        return rqst.data
    }
    async myTeamPerformanceChart(data) {
        const rqst = await http.post('performance/team/chart/', data)
        return rqst.data
    }
    async messageTakePerformanceReview(data) {
        const rqst = await http.post('performance/review/message/', data)
        return rqst.data
    }
    async takePerformanceReview(data) {
        const rqst = await http.post('performance/review/take/', data)
        return rqst.data
    }
    async takePerformanceReviewSummary(data) {
        const rqst = await http.post('performance/review/take/summary/', data)
        return rqst.data
    }
    async createItemStatus(data) {
        const rqst = await http.post('performance/review/item-status/create/', data)
        return rqst.data
    }
    async getItemStatus(data) {
        const rqst = await http.post('performance/review/item-status/get/', data)
        return rqst.data
    }
    async updateItemStatus(data) {
        const rqst = await http.post('performance/review/item-status/update/', data)
        return rqst.data
    }
    async createPerformanceStatus(data) {
        const rqst = await http.post('performance/status/create/', data)
        return rqst.data
    }
    async listPerformanceStatus(data) {
        const rqst = await http.post('performance/status/list/', data)
        return rqst.data
    }
    async PerformanceMatrixGet(data) {
        const rqst = await http.post('performance/matrix/get/', data)
        return rqst.data
    }
    async createPerformanceMatrix(data) {
        const rqst = await http.post('performance/matrix/create/', data)
        return rqst.data
    }
    async calibratePerformanceMatrix(data) {
        const rqst = await http.post('performance/matrix/calibrate/', data)
        return rqst.data
    }
    async generalPerformanceMatrixGet(data) {
        const rqst = await http.post('performance/general/matrix/get/', data)
        return rqst.data
    }
    async importCompetencyJobPerformance(data) {
        const rqst = await http.post('performance/import/competencies/', data)
        return rqst.data
    }
    async listAssessmentQuestions(page, data) {
        const rqst = await http.post('assessment-question/list/?page=' + page, data)
        return rqst.data
    }
    async importQuestionJobPerformance(data) {
        const rqst = await http.post('performance/import/questions/', data)
        return rqst.data
    }
    async deletePerformanceSession(data) {
        const rqst = await http.post('performance/session/delete/', data)
        return rqst.data
    }
    async createPerformanceTemplate(data) {
        const rqst = await http.post('performance/template/create/', data)
        return rqst.data
    }
    async updatePerformanceTemplate(data) {
        const rqst = await http.post('performance/template/update/', data)
        return rqst.data
    }
    async getPerformanceTemplate(id) {
        let data = {
            company_id: localStorage.getItem("companyId"),
            id: id
        }
        const rqst = await http.post('performance/template/get/', data)
        return rqst.data
    }
    async addParticipantsPerformanceTemplate(data) {
        const rqst = await http.post('performance/template/add/participants/', data)
        return rqst.data
    }
    async listPerformanceReviewGoals(data) {
        const rqst = await http.post('performance/list/goals/', data)
        return rqst.data
    }
    async importPerformanceReviewGoals(data) {
        const rqst = await http.post('performance/import/goals/', data)
        return rqst.data
    }
    async updatePerformanceTemplateContent(data) {
        const rqst = await http.post('performance/template/update/content/', data)
        return rqst.data
    }
    async createReviewsFromPerformanceTemplate(data) {
        const rqst = await http.post('performance/template/create/reviews/', data)
        return rqst.data
    }
    async clonePerformanceTemplate(data) {
        const rqst = await http.post('performance/template/clone/', data)
        return rqst.data
    }
    async updatePerformanceStepSuperior(data) {
        const rqst = await http.post('performance-step/superior/update/', data)
        return rqst.data
    }
    async listEmployeePerformanceSteps(data) {
        const rqst = await http.post('performance/employee/steps/', data)
        return rqst.data
    }
    async performanceStepDetail(data) {
        const rqst = await http.post('performance/step/detail/', data)
        return rqst.data
    }
    async listPerformanceTemplate(page, data) {
        const rqst = await http.post('performance/template/list/?page=' + page, data)
        return rqst.data
    }
    async listPerformanceTemplateManager(data) {
        const rqst = await http.post('performance/template/list/manager/', data)
        return rqst.data
    }
    async listPerformanceReviewManager(data) {
        const rqst = await http.post('performance/review/list/manager/', data)
        return rqst.data
    }
    async removeParticipantPerformanceReview(data) {
        const rqst = await http.post('performance/review/remove/participant/', data)
        return rqst.data
    }
    async getPerformanceTemplateReport(page, data) {
        const rqst = await http.post('performance/template/report/?page=' + page, data)
        return rqst.data
    }
    async getPerformanceReviewReport(data) {
        const rqst = await http.post('performance/review/report/', data)
        return rqst.data
    }
    async exportPerformanceReviewReport(data) {
        const rqst = await http.post('performance/review/report/export/', data)
        return rqst.data
    }
    async exportEmployeeReviewReport(data) {
        const rqst = await http.post('performance/review/report/employee/export/', data)
        return rqst.data
    }
    async removePerformanceProcess(data) {
        const rqst = await http.post('performance/review/remove-process/', data)
        return rqst.data
    }
    async removeLeaderProcess(data) {
        const rqst = await http.post('performance/review/remove-leader/', data)
        return rqst.data
    }
    async getMyPendingSteps(data) {
        const rqst = await http.post('performance/my-pending-steps/', data)
        return rqst.data
    }
    async createActionPlan(data) {
        const rqst = await http.post('performance/action-plan/create/', data)
        return rqst.data
    }
    async updateActionPlan(data) {
        const rqst = await http.post('performance/action-plan/update/', data)
        return rqst.data
    }
    async takeDevelopmentPlan(data) {
        const rqst = await http.post('performance/development-plan/take/', data)
        return rqst.data
    }
    async createActionPlanStatus(data) {
        const rqst = await http.post('performance/action-plan/status/create/', data)
        return rqst.data
    }
    async confirmTakeDevelopmentPlan(data) {
        const rqst = await http.post('performance/development-plan/confirm/', data)
        return rqst.data
    }
    async deleteActionPlan(data) {
        const rqst = await http.post('performance/action-plan/delete/', data)
        return rqst.data
    }
    async developmentPlanDetail(data) {
        const rqst = await http.post('performance/development-plan/detail/', data)
        return rqst.data
    }

    // Feedback
    async feedbackDashboardSummary(employeeId) {
        const data = { company_id: localStorage.getItem("companyId") }
        if (employeeId) data.employee_id = employeeId
        const rqst = await http.post('feedback/dashboard/summary/', data)
        return rqst.data
    }
    async createFeedbackRequest(data) {
        const rqst = await http.post('feedback/request/create/', data)
        return rqst.data
    }
    async deleteFeedbackRequest(id) {
        const data = { company_id: localStorage.getItem("companyId"), id }
        const rqst = await http.post('feedback/request/delete/', data)
        return rqst.data
    }
    async listFeedbackRequestsSent(page) {
        const data = { company_id: localStorage.getItem("companyId") }
        const rqst = await http.post('feedback/request/list/sent/?page=' + page, data)
        return rqst.data
    }
    async listFeedbackRequestsPending(page) {
        const data = { company_id: localStorage.getItem("companyId") }
        const rqst = await http.post('feedback/request/list/pending/?page=' + page, data)
        return rqst.data
    }
    async giveFeedback(data) {
        const rqst = await http.post('feedback/give/', data)
        return rqst.data
    }
    async listFeedbackReceived(page, employeeId) {
        const data = { company_id: localStorage.getItem("companyId") }
        if (employeeId) data.employee_id = employeeId
        const rqst = await http.post('feedback/received/list/?page=' + page, data)
        return rqst.data
    }
    async listFeedbackGiven(page) {
        const data = { company_id: localStorage.getItem("companyId") }
        const rqst = await http.post('feedback/given/list/?page=' + page, data)
        return rqst.data
    }

    // 360º — peers
    async addPeerStep(data) {
        const rqst = await http.post('performance/360/peer/add/', {
            company_id: localStorage.getItem("companyId"),
            ...data,
        })
        return rqst.data
    }
    async addAllPeerSteps(reviewId) {
        const rqst = await http.post('performance/360/peer/add-all/', {
            company_id: localStorage.getItem("companyId"),
            review_id: reviewId,
        })
        return rqst.data
    }
    async removePeerStep(stepId) {
        const rqst = await http.post('performance/360/peer/remove/', {
            company_id: localStorage.getItem("companyId"),
            step_id: stepId,
        })
        return rqst.data
    }
    async listPeerSteps(reviewId, employeeId) {
        const data = {
            company_id: localStorage.getItem("companyId"),
            review_id: reviewId,
        }
        if (employeeId) data.employee_id = employeeId
        const rqst = await http.post('performance/360/peer/list/', data)
        return rqst.data
    }

    // 360º — pesos das etapas
    async listStepWeights(templateId, reviewId) {
        const body = { company_id: localStorage.getItem("companyId") }
        if (templateId) body.template_id = templateId
        else if (reviewId) body.review_id = reviewId
        const rqst = await http.post('performance/360/step-weights/list/', body)
        return rqst.data
    }
    async saveStepWeights(templateId, weights, reviewId) {
        const body = { company_id: localStorage.getItem("companyId"), weights }
        if (templateId) body.template_id = templateId
        else if (reviewId) body.review_id = reviewId
        const rqst = await http.post('performance/360/step-weights/save/', body)
        return rqst.data
    }

    // Comitê de Calibração
    async getCalibrationConfig(scope) {
        const body = { company_id: localStorage.getItem("companyId") }
        if (scope.template_id) body.template_id = scope.template_id
        if (scope.review_id) body.review_id = scope.review_id
        const rqst = await http.post('performance/calibration/config/get/', body)
        return rqst.data
    }
    async saveCalibrationConfig(data) {
        const rqst = await http.post('performance/calibration/config/save/', {
            company_id: localStorage.getItem("companyId"),
            ...data,
        })
        return rqst.data
    }
    async listCalibrationCommittee(data) {
        const rqst = await http.post('performance/calibration/list/', {
            company_id: localStorage.getItem("companyId"),
            ...data,
        })
        return rqst.data
    }
    async listCalibrationManagers(scope) {
        const body = { company_id: localStorage.getItem("companyId") }
        if (scope.template_id) body.template_id = scope.template_id
        if (scope.review_id) body.review_id = scope.review_id
        const rqst = await http.post('performance/calibration/managers/', body)
        return rqst.data
    }
    async getCalibrationDetail(data) {
        const rqst = await http.post('performance/calibration/detail/', {
            company_id: localStorage.getItem("companyId"),
            ...data,
        })
        return rqst.data
    }
    async previewCalibration(data) {
        const rqst = await http.post('performance/calibration/preview/', {
            company_id: localStorage.getItem("companyId"),
            ...data,
        })
        return rqst.data
    }
    async submitCalibration(data) {
        const rqst = await http.post('performance/calibration/submit/', {
            company_id: localStorage.getItem("companyId"),
            ...data,
        })
        return rqst.data
    }
    async getCalibrationHistory(scope) {
        const body = { company_id: localStorage.getItem("companyId") }
        if (scope.template_id) body.template_id = scope.template_id
        if (scope.review_id) body.review_id = scope.review_id
        const rqst = await http.post('performance/calibration/history/', body)
        return rqst.data
    }
    async listCalibrationParticipants() {
        const rqst = await http.post('performance/calibration/participants/list/', {
            company_id: localStorage.getItem("companyId"),
        })
        return rqst.data
    }
    async saveCalibrationDraft(data) {
        const rqst = await http.post('performance/calibration/draft/save/', {
            company_id: localStorage.getItem("companyId"),
            ...data,
        })
        return rqst.data
    }
    async getCalibrationVersions(data) {
        const rqst = await http.post('performance/calibration/versions/', {
            company_id: localStorage.getItem("companyId"),
            ...data,
        })
        return rqst.data
    }
    async getCalibrationDistribution(scope) {
        const body = { company_id: localStorage.getItem("companyId") }
        if (scope.template_id) body.template_id = scope.template_id
        if (scope.review_id) body.review_id = scope.review_id
        if (scope.manager_id) body.manager_id = scope.manager_id
        if (scope.status) body.status = scope.status
        const rqst = await http.post('performance/calibration/distribution/', body)
        return rqst.data
    }
    async exportCalibration(data) {
        const rqst = await http.post('performance/calibration/export/', {
            company_id: localStorage.getItem("companyId"),
            ...data,
        }, { responseType: 'blob' })
        return rqst
    }
}

const performanceService = new PerformanceService()

export default performanceService
